import http from '@/lib/http.js';
import * as localForage from 'localforage';
import nanoid from 'nanoid';
import extensionDriver from '@/lib/extension-driver.js';
import blockSpec from '@/lib/spec.js';

let store = null;
let mode = window.mode;

localForage.defineDriver(extensionDriver);

store = localForage.createInstance({
	name: 'um',
	driver: localForage.LOCALSTORAGE
});

function Storage() {
	this.get = async function(key) {
		let res = null;
		res = await store.getItem(key);
		return res;
	};

	this.set = async function(key, data) {
		let res = null;
		res = await store.setItem(key, data);
		return res;
	};

	this.remove = async function(key) {
		let res = null;
		res = await store.removeItem(key);
		return res;
	};
}

let storage = new Storage();
let self = null;

export default {
	async init(m) {
		self = this;
		mode = m || window.mode;
		if (mode === 'EXTENSION') {
			store.setDriver('extensionDriver');
		}
		return true;
	},

	settings: {
		async getSettings() {
			res = await storage.get('settings');
			return res;
		}
	},

	blocks: {
		async getBlocks() {
			let res = [];
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/blocks/all');
				return res.data;
			}
			if (mode === 'LOCAL') {
				res = (await storage.get('blocks')) || [];
				return res;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:get'
				});
				res = response;
				return res;
			}
		},
		async addBlock(block) {
			let res = false;
			if (mode === 'LOCAL') {
				let blocks = (await storage.get('blocks')) || [];
				res = blockSpec.createBlock(block);
				blocks.push(res);
				blocks = await storage.set('blocks', blocks);
				return res;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:add',
					block: block
				});
				res = response;
				return res;
			}
		},
		async deleteBlock(block) {
			let res = false;
			if (mode === 'LOCAL') {
				let blocks = (await storage.get('blocks')) || [];
				for (let i = 0; i < blocks.length; i++) {
					if (blocks[i]._id === block._id) {
						blocks.splice(i, 1);
						break;
					}
				}
				blocks = await storage.set('blocks', blocks);
				return res;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:deleteBlock',
					block: block
				});
				res = response;
				return res;
			}
		},
		async bulkDeleteBlocks(newBlocks) {
			let res = false;
			if (mode === 'LOCAL') {
				let blocks = (await storage.get('blocks')) || [];
				blocks = blocks.filter(block => {
					let match = true;
					for (let i = 0; i < newBlocks.length; i++) {
						if (newBlocks[i]._id === block._id) {
							match = false;
							break;
						}
					}
					return match;
				});
				blocks = await storage.set('blocks', blocks);
				return res;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:bulkDeleteBlocks',
					block: block
				});
				res = response;
				return res;
			}
		},
		// temp function, used only to bulk add blocks via the notestoblock action
		async bulkAddBlocks(newBlocks) {
			if (mode === 'LOCAL') {
				let blocks = (await storage.get('blocks')) || [];
				blocks = blocks.concat(newBlocks);
				blocks = await storage.set('blocks', blocks);
				return blocks;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:bulkAddBlocks',
					newBlocks: newBlocks
				});
				return response;
			}
		},
		async updateBlock(block) {
			let res = false;
			if (mode === 'LOCAL') {
				let blocks = (await storage.get('blocks')) || [];
				blocks = blocks.map(b => {
					if (b._id === block._id) {
						b = block;
					}
					return b;
				});
				await storage.set('blocks', blocks);
				return block;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:update',
					block: block
				});
				return response;
			}
		},
		async bulkRemoveBlocks(newBlocks) {
			let res = false;
			if (mode === 'LOCAL') {
				let blocks = (await storage.get('blocks')) || [];
				blocks = blocks.filter(block => {
					if (newBlocks.includes(block._id)) {
						return false;
					} else {
						return true;
					}
				});
				await storage.set('blocks', blocks);
				return newBlocks;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:bulkRemove',
					blocks: newBlocks
				});
				return response;
			}
		},
		async bulkUpdateBlocks(newBlocks) {
			let res = false;
			if (mode === 'LOCAL') {
				let blocks = (await storage.get('blocks')) || [];
				for (let i = 0; i < blocks.length; i++) {
					for (let j = 0; j < newBlocks.length; j++) {
						if (newBlocks[j]._id === blocks[i]._id) {
							blocks[i] = newBlocks[j];
							break;
						}
					}
				}
				await storage.set('blocks', blocks);
				return newBlocks;
			}
			if (mode === 'EXTENSION') {
				let response = await browser.runtime.sendMessage({
					type: 'blocks:bulkUpdateBlocks',
					blocks: newBlocks
				});
				return response;
			}
		},

		// Extension specific stuff
		async backgroundGetBlocks() {
			let res = false;
			res = (await storage.get('blocks')) || [];
			return res;
		},
		async backgroundAddBlock(block) {
			let res = false;
			let blocks = (await storage.get('blocks')) || [];
			res = blockSpec.createBlock(block);
			blocks.push(res);
			blocks = await storage.set('blocks', blocks);
			return res;
		},
		async backgroundBulkAddBlocks(newBlocks) {
			let blocks = (await storage.get('blocks')) || [];
			blocks = blocks.concat(newBlocks);
			blocks = await storage.set('blocks', blocks);
			return blocks;
		},
		async backgroundUpdateBlock(block) {
			let blocks = (await storage.get('blocks')) || [];
			blocks = blocks.map(b => {
				if (b._id === block._id) {
					b = block;
				}
				return b;
			});
			let data = null;
			data = await storage.set('blocks', blocks);
			return block;
		},
		async backgroundBulkDeleteBlocks(newBlocks) {
			let blocks = (await storage.get('blocks')) || [];
			blocks = blocks.filter(block => {
				if (newBlocks.includes(block._id)) {
					return false;
				} else {
					return true;
				}
			});
			await storage.set('blocks', blocks);
			return newBlocks;
		},
		async backgroundBulkUpdateBlocks(newBlocks) {
			let blocks = (await storage.get('blocks')) || [];
			for (let i = 0; i < blocks.length; i++) {
				for (let j = 0; j < newBlocks.length; j++) {
					if (newBlocks[j]._id === blocks[i]._id) {
						blocks[i] = newBlocks[j];
						break;
					}
				}
			}
			await storage.set('blocks', blocks);
			return newBlocks;
		},

		async transactionCreateBlock(data) {
			let res = null;
			let blockData = data.blockData;
			let parentBlock = data.parentBlock;
			let block = await this.addBlock(blockData.block);
			if (!block) {
				return res;
			}

			parentBlock.blocks.splice(blockData.position, 0, block._id);

			let update = await this.updateBlock(parentBlock);

			return block;
		},

		async transactionBulkAddBlocks(data) {
			await this.bulkAddBlocks(data.blocksArray);
			await this.updateBlock(data.parentBlock);
			return true;
		}
	},

	transactions: {
		async run(arr) {
			let resultsArray = [];
			if (mode === 'LOCAL' || mode === 'EXTENSION') {
				for (let i = 0; i < arr.length; i++) {
					let name = arr[i].name.split('/')[1];
					let res = await self.blocks[name](arr[i].payload);
					resultsArray.push(res);
				}
			}
			//console.log(resultsArray);
		}
	},

	users: {
		async login(form) {
			let res = false;
			/**
			 * Mode doesnt matter. It has to get initial login from the server, except if running locally
			 */
			// if (mode === 'LOCAL') {
			// 	res = {
			// 		data: await storage.get('user')
			// 	};
			// }
			// if (mode === 'WEBAPP') {
			// 	res = await http.request('post', '/users/login', form);
			// }
			// if (mode === 'EXTENSION') {
			// 	res = {
			// 		data: await storage.get('user')
			// 	};
			// }
			res = await http.request('post', '/users/login', form);
			// if (mode === 'WEBAPP') {
			// 	res = await http.request('post', '/users/login', form);
			// } else if (mode === 'EXTENSION') {
			// 	res = {
			// 		data: await storage.get('user')
			// 	};
			// }
			return res;
		},
		async signup(form) {
			return await http.request('post', '/users/headless-signup', form);
		},
		async setToken(token) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await storage.set('token', token);
			}
			if (mode === 'LOCAL') {
				res = await storage.set('token', token);
			}
			if (mode === 'EXTENSION') {
				res = await browser.runtime.sendMessage({
					type: 'user:setToken',
					token: token
				});
			}
			return res;
		},
		async getToken() {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await storage.get('token');
				return res;
			}
			if (mode === 'LOCAL') {
				res = await storage.get('token');
				return res;
			}
			if (mode === 'EXTENSION') {
				res = await browser.runtime.sendMessage({
					type: 'user:getToken'
				});
				return res;
			}
		},
		async removeToken() {
			if (mode === 'WEBAPP') {
				return await storage.remove('token');
			}
			if (mode === 'LOCAL') {
				return await storage.remove('token');
			}
			if (mode === 'EXTENSION') {
				return await storage.remove('token');
			}
		},

		async backgroundGetToken() {
			let token = (await storage.get('token')) || '';
			return token;
		},
		async backgroundSetToken(token) {
			let res = await storage.set('token', token);
			return res;
		}
	},

	notes: {
		async getNotes() {
			let res = await http.request('post', '/notes/all', {});
			return res;
		}
	},

	marketing: {
		async saveState(data) {
			await storage.set('marketing', data);
		},
		async getState() {
			return (await storage.get('marketing')) || [];
		}
	},

	app: {}
};
